
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/extraPage/ExtraPage",
      function () {
        return require("private-next-pages/extraPage/ExtraPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/extraPage/ExtraPage"])
      });
    }
  